import { render, staticRenderFns } from "./detailscc.vue?vue&type=template&id=c922c9ce&scoped=true&"
import script from "./detailscc.vue?vue&type=script&lang=js&"
export * from "./detailscc.vue?vue&type=script&lang=js&"
import style0 from "./detailscc.vue?vue&type=style&index=0&id=c922c9ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c922c9ce",
  null
  
)

component.options.__file = "detailscc.vue"
export default component.exports